import { CSSProperties } from 'react'

import styled from '@emotion/styled'

import { colors } from '../../theme/colors'
import spacing from '../../theme/spacing'

const isSpacing = (space: keyof typeof spacing | string): space is keyof typeof spacing =>
  (space as keyof typeof spacing) in spacing

const parsePadding = (padding: string) =>
  padding
    .split(/\s/)
    .map(p => (isSpacing(p) ? spacing[p] : p))
    .join(' ')

interface BoxProps {
  backgroundColor?: keyof typeof colors
  border?: CSSProperties['border']
  borderBottom?: CSSProperties['borderBottom']
  borderLeft?: CSSProperties['borderLeft']
  borderRadius?: CSSProperties['borderRadius']
  borderRight?: CSSProperties['borderRight']
  borderTop?: CSSProperties['borderTop']
  fullHeight?: boolean
  overflow?: CSSProperties['overflow']
  padding?: string
}

export const Box = styled.div<BoxProps>`
  ${({ backgroundColor, theme }) => backgroundColor && `background-color: ${theme.colors[backgroundColor]}`};
  ${({ border }) => border && `border: ${border}`};
  ${({ borderBottom }) => borderBottom && `border-bottom: ${borderBottom}`};
  ${({ borderLeft }) => borderLeft && `border-left: ${borderLeft}`};
  ${({ borderRadius }) => borderRadius && `border-radius: ${borderRadius}`};
  ${({ borderRight }) => borderRight && `border-right: ${borderRight}`};
  ${({ borderTop }) => borderTop && `border-top: ${borderTop}`};
  ${({ fullHeight }) => fullHeight && `min-height: 100%`};
  ${({ overflow }) => overflow && `overflow: ${overflow}`};
  ${({ padding }) => padding && `padding: ${parsePadding(padding)}`};
`
